import { Link } from "@mui/material";
import { TERMS_OF_USE_URL } from "user-management/src/components/termAndConditionsLinks";
import React, { CSSProperties } from "react";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { InfoPopover } from "./infoPopover";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LlmDisclaimerProps {
  iconStyle?: CSSProperties;
  inExtension?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LLMDisclaimer = ({ iconStyle, ...props }: LlmDisclaimerProps) => {
  const { translate } = useTranslateByGender();
  return (
    <InfoPopover
      text={
        <>
          {translate("LLM_DISCLAIMER")}
          <Link
            href={`${TERMS_OF_USE_URL}#third-party`}
            target="_blank"
            style={{ marginLeft: 4 }}
          >
            {translate("LLM_DISCLAIMER_MORE")}
          </Link>
        </>
      }
      open={false}
      iconStyle={iconStyle}
      inExtension={props.inExtension}
    />
  );
};
